module.exports = __webpack_public_path__ + "img/qris.29b009e1.png";